import React from 'react';
import { Button, Card, Table, Tag, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CHANGELOG } from '../changelog';
import { APP_VERSION } from '../services/api';

const { Title, Text } = Typography;

type Row = {
  key: string;
  version: string;
  date: string;
  changes: string[];
};

export default function ChangelogPage() {
  const navigate = useNavigate();

  const rows: Row[] = React.useMemo(
    () =>
      CHANGELOG.map((e) => ({
        key: `${e.version}_${e.date}`,
        version: e.version,
        date: e.date,
        changes: e.changes,
      })),
    []
  );

  return (
    <Card>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <div>
          <Title level={3} style={{ marginTop: 0, marginBottom: 6 }}>
            Журнал изменений
          </Title>
          <Text type="secondary">Текущая версия: </Text>
          <Tag color="blue" style={{ marginLeft: 6 }}>
            v{APP_VERSION}
          </Tag>
        </div>
        <Button onClick={() => navigate(-1)}>Назад</Button>
      </div>

      <Table<Row>
        style={{ marginTop: 16 }}
        dataSource={rows}
        pagination={false}
        columns={[
          {
            title: 'Версия',
            dataIndex: 'version',
            key: 'version',
            width: 140,
            render: (v: string) => <Tag color={v === APP_VERSION ? 'green' : 'default'}>v{v}</Tag>,
          },
          { title: 'Дата', dataIndex: 'date', key: 'date', width: 140 },
          {
            title: 'Что изменилось',
            dataIndex: 'changes',
            key: 'changes',
            render: (items: string[]) => (
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {(items || []).map((c, idx) => (
                  <li key={idx}>{c}</li>
                ))}
              </ul>
            ),
          },
        ]}
      />
    </Card>
  );
}

